import { render, staticRenderFns } from "./MainTabTemplate.vue?vue&type=template&id=737930d4&"
import script from "./MainTabTemplate.vue?vue&type=script&lang=js&"
export * from "./MainTabTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports